import React, { useState, useEffect, useCallback , useRef,memo } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Collapse,
  Box,
  Button,
  Paper,
} from "@mui/material";
import { CancelPresentationRounded, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import useStyles from "./style";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom'
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
//Services
import HotelApi from "Services/Hotel";

const UpcomingtripsPage = () => {
const dispatch = useDispatch();
const [rows, setrows] = useState([]);
const classes = useStyles();
const navigate = useNavigate();

   const getupcomingrides = useCallback(() => {
  dispatch(showLoader("Loading please wait..."));
  const onSuccess = (res) => {
    dispatch(hideLoader());
 //   console.log("fetched user request data--->",res?.data);
    if (res?.data?.status === true) {
   console.log("fetched active service data--->",res?.data?.data?.data)
      setrows(res?.data?.data?.data);
    } else {
      setrows([]);
    }
  };
  const onFailure = (err) => {
    dispatch(hideLoader());
    dispatch(
      showSnackbar({
        message: err?.response?.data?.message || "Failed to fetch data",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      })
    );
    //console.log("Get member / partner details Api", err);
  };
  HotelApi.getupcomingtrips().then(onSuccess, onFailure);
}, []);

  useEffect(() => {
    getupcomingrides();
  }, []);   


// handle cancel ride

   const cancelride = useCallback((rideid) => {
console.log(rideid);
    dispatch(showLoader("Loading please wait..."));
  const onSuccess = (res) => {
    dispatch(hideLoader());
    //console.log("fetched user request data--->",res?.data);
    if (res?.data?.status === true) {
        navigate('/mytrips_hotel');
  }
};
  const onFailure = (err) => {
    dispatch(hideLoader());
    dispatch(
      showSnackbar({
        message: err?.response?.data?.message || "Error while cancel ride",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      })
    );
    //console.log("Get member / partner details Api", err);
  };
  HotelApi.cancelridebyid(rideid).then(onSuccess, onFailure);
}, []);

  const handlecancelride = (row) => {
    cancelride(row._id);
  };  

  const [openRow, setOpenRow] = useState(null);

  return (
    <Grid container sx={{ height: "100vh" }}>
      {/* Left side table */}
      <Grid item xs={12} md={7} sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom className={classes.spaceme} sx={{fontWeight: "bold" }}>
          Upcoming Trips
        </Typography>
        <Paper>
          <Table>
            <TableHead >
              <TableRow className={classes.tableheader}>
                <TableCell />
                <TableCell>Booking Id</TableCell>
                <TableCell>Scheduled Date</TableCell>
                <TableCell>Customer Name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Payment</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <React.Fragment key={row.bookingId}>
                  <TableRow>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() =>
                          setOpenRow(openRow === index ? null : index)
                        }
                      >
                      {openRow === index ? (
                      <KeyboardArrowDown />
                      ) : (
                      <KeyboardArrowUp /> 
                      )}
                      </IconButton>
                    </TableCell>
                    <TableCell>{row.bookingId}</TableCell>
                    <TableCell>  {new Date(row.tripBookedAt).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false,
                    })}</TableCell>
                    <TableCell>{row.user_name}</TableCell>
                    <TableCell>{row.service_name}</TableCell>
                    <TableCell>{row.paymentMode}</TableCell>
                    <TableCell>{row.tripStatus}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={7} sx={{ p: 0 }}>
                      <Collapse in={openRow === index} timeout="auto" unmountOnExit>
                        <Box sx={{ p: 2 }}>
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <Typography>
                                <strong>From:</strong> 
                              </Typography>
                                                            <Typography className={classes.spaceme}>{row.pickupAddress}</Typography>
                              <Typography>
                                <strong>To:</strong>
                              </Typography>
                                                            <Typography className={classes.spaceme} >{row.dropAddress}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography>
                                <strong>Provider Details:</strong>
                                </Typography>
        <Typography className={classes.spaceme} >{
        row.tripStatus == "SEARCHING" ? "Driver Not yet Assigned.":row.tripStatus }
        </Typography>
                            </Grid>
                          </Grid>
                          <Box mt={2}>
                            <Button
                              variant="contained"
                              color="error"
                              size="small"
                              className={classes.cancelbutton}
                             onClick={() => {
                            handlecancelride(row);
                          }}
                            >
                              Cancel Ride
                            </Button>
                          </Box>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Grid>

      {/* Right side static image */}
      <Grid
        item
        xs={12}
        md={5}
        className={classes.rightimage}
      />
    </Grid>
  );
};

export default UpcomingtripsPage;
